import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class DeviceLoginService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Create new login flow for device basing on user code
     * @returns LoginResult OK.
     * @throws ApiError
     */
    loginDeviceWithUserCode({ requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/api/device-logins', body: requestBody, mediaType: 'application/json', errors: {
                400: `Invalid/expired user code provided.`,
                404: `Invalid/non-existing user code provided.`,
                500: `Internal server error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=DeviceLoginService.js.map